<template>
  <div class="Terms">
    <b-breadcrumb :items="items"></b-breadcrumb>
    <div class="title">
      <h1 class="font-weight-bold float-left pl-5 ">隱私權政策</h1>
    </div>
    <hr>
    <div class="terms container">
      <b-tabs class="tabs"
              content-class="mt-3">
        <b-tab title="隱私權條款"
               active>
          <h3>cama 網路會員隱私權條款</h3>
          <p> 咖碼股份有限公司（下稱本公司）為提供您更多完善及多元之服務及商品，對於您所提供與本公司之個人資料，將依個人資料保護法之規定來使用、保管您所提供之個人資料，並維護您的隱私權。同時，本網站對於您個人資料之使用、蒐集將依下列聲明為利用、管理。</p>
          <h3>客戶資料使用目的 </h3>
          <p> 本公司基於商業與技術資訊、客戶管理、會員管理、行銷、資訊與資料庫管理、統計調查與分析、其他合於營業登記項目或章程所定業務之需要等目的，將蒐集並於前述目的範圍內利用您所提供之個人資料。</p>
          <h3>客戶資料蒐集方式、利用範圍 </h3>
          <p> 當您使用本公司服務及商品時，本網站基於服務之提供或商品之銷售，將會請您填寫服務所需之相關資料（EX.會員註冊申請、商品宅配資料、退款、禮贈品之聯繫寄送或兌換等其他行銷活動或基於服務需要），本公司將藉由加入會員之過程或進行交易之過程來蒐集您個人資料。本公司僅將您個人資料使用在您所需之服務上。</p>
          <h3>客戶資料分類及項目 </h3>
          <p> 本公司依所提供之服務需要，可能需請您提供的個人資料種類，包括基本資料、帳務資料，分類標準如下：</p>
          <p>(一) 基本資料：包括姓名、出生年月日、身分證統一編號、電話、地址、電子郵件信箱… 等資料。</p>
          <p>(二) 帳務資料：包括帳戶號碼或類似功能號碼、信用卡帳號、存款帳號、交易帳戶號碼等資料。</p>
          <h3>客戶資料使用期間、使用區域</h3>
          <p>(一) 本公司將持續使用您提供的個人資料直至您提出停止使用或本公司停止提供服務之日為止。</p>
          <p>(二) 您的個人資料使用區域僅限於台灣地區內使用，並為提供您更完善、更多元的服務以及更好之服務品質，我們將會在法令許可或您同意下，將您的資料提供給合作之商品配送業者、商品供應商或關係企業，以提供您所需的個別服務、行銷活動及相關優惠訊息給您。</p>
          <h3>資料安全</h3>
          <p>為保障會員隱私及安全，本公司之會員帳號資料將以加密方式保護。本公司並盡力以合理之技術及程序，保障所有個人資料之安全。</p>
          <h3>資料更新</h3>
          <p>您可以使用在本公司所註冊之帳號與密碼來更新您個人資料，可更新登入密碼、地址(訂閱制請撥打客服電話更改)、郵件地址;姓名、性別、生日等欄位不可更新，註冊時請確實填寫。交易紀錄、付款資料…等欄位亦不在修改範圍內(如欲更換付款資料，請撥打客服電話)。</p>
        </b-tab>
        <b-tab title="服務條款">
          <h3>cama 網路會員服務條款</h3>
          <p> 親愛的顧客您好，非常感謝您使用咖碼股份有限公司（下稱本公司）的網路服務（下稱本服務），本公司將根據以下之網路會員服務條款（下稱本條款），提供會員便利的網路交易及網路服務。為了保障您的權益，請務必詳讀本條款，在您註冊成為本公司網路會員、或開始使用本服務時，即視為您已經閱讀、瞭解並同意接受本條款及「隱私權條款」之所有內容，且完全接受本服務現有與未來衍生的服務項目及內容，並視為您已確認詳閱並同意個人資料保護告知暨同意事項。如您不同意本條款之全部或部分內容，請勿註冊，並請立即停止使用本服務。本條款之具體約定內容如後：</p>
          <h3>一、網路會員註冊義務</h3>
          <p>為使用本服務，會員應同意以下事項：</p>
          <p>(一) 會員註冊時應提供本人最新且正確之個人資料，且不得以第三人名義註冊為會員。每位會員僅能註冊登錄一個帳號，不可重覆註冊登錄。</p>
          <p>(二) 會員應隨時維護並更新會員個人資料，確保會員資料之正確性，以獲取最佳之服務。</p>
          <p>(三) 若會員提供任何不實資料、或拒絕提供必要資料、 或有重覆註冊帳號…等情事時，本公司有權不經事先通知，逕行暫停或終止會員帳號，並拒絕會員使用本服務之全部或一部。</p>
        </b-tab>
        <b-tab title="退換貨需知">
          <h3>一、退換貨限制與規則：</h3>
          <p>於本網站完成購物，消費者依消費者保護法第19條第1項之規定享有7天鑑賞期，為保障您的權益，請於開箱時全程錄影。相關說明如下：</p>
          <h4>退貨：</h4>
          <ul>
            <li>瑕疵商品退貨前請先聯繫客服 service@camacafe.com 或撥打客服專線0800-068-566說明貨品狀況，確認是否可以退貨。</li>
            <li>如確認退貨，總公司將派專人至府上收取。</li>
          </ul>
          <h4>訂閱制退貨：</h4>
          <ul>
            <li>產品欲辦理退貨，請先聯繫客服 service@camacafe.com，或撥打客服專線0800-068-566說明貨品狀況，確認是否可以退貨。</li>
            <li>須完成填寫「退貨申請書」並回傳給cama總公司，併同返還優惠差額至本公司所提供之虛擬帳號。</li>
            <li>申請退貨後請將商品寄回cama總公司（台北市大安區安和路一段27號18樓 ）。</li>
          </ul>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data () {
    return {
      items: [
        {
          text: '首頁',
          to: { name: 'Home' }
        },
        {
          text: '隱私權政策',
          active: true
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
.Terms {
  overflow: hidden;
  .tabs {
    overflow: hidden;
    text-align: left;
  }
  .terms {
    overflow: hidden;
  }
}
</style>
